/**
 * Layout paramètres : contenu limité à 650px (onglets = sous-barre dans NavbarSite).
 */
const SettingsLayout = ({ children }) => (
  <div className="flex w-full max-w-[650px] flex-1 flex-col min-h-0 gap-6">
    {children}
  </div>
);

export default SettingsLayout;
